module.exports = __webpack_public_path__ + "reference.png?d0289dc0a46fc5b15b3363ffa78cf6c7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/client/reference.png
// module id = 380
// module chunks = 0